import { QueryClient } from '@tanstack/react-query';
import axios from 'axios';

// Defaults chosen to match Angular behavior: no automatic refetch on focus,
// limited retries (HTTP errors are usually deterministic in this app), and
// never retry auth failures — those are handled by the global 401 interceptor.
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    if (status === 401 || status === 403) return false;
  }
  return failureCount < 1;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetry,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: {
      retry: 0,
    },
  },
});
